module.exports = __webpack_public_path__ + "static/media/iconDefuncion01.dbe08f4f.svg";